// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-brand {
  max-height: 60px;
  margin: 0;
  padding: 0;
  object-fit: contain;
}

.card {
  margin-top: 60px;
  border-radius: 8px !important;
}

.card-header {
  position: relative;
  top: -40px;
  border-radius: 8px !important;
}

.card-body {
  margin-top: -20px;
  padding: 0px 16px 16px !important;
}

.cadastro-title {
  text-transform: uppercase;
  margin-bottom: 16px;
}

.cadastro-voltar {
  font-weight: var(--app-font-weight-semibold);
  text-decoration: none;
}

.cadastro-voltar:hover {
  text-decoration: underline;
}

@media (max-width: 360px) {
  .login-brand {
    height: 40px;
  }
}
@media (max-width: 280px) {
  .login-brand {
    height: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/main/cadastro-usuario/cadastro-usuario.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".login-brand {\n  max-height: 60px;\n  margin: 0;\n  padding: 0;\n  object-fit: contain;\n}\n\n.card {\n  margin-top: 60px;\n  border-radius: 8px !important;\n}\n\n.card-header {\n  position: relative;\n  top: -40px;\n  border-radius: 8px !important;\n}\n\n.card-body {\n  margin-top: -20px;\n  padding: 0px 16px 16px !important;\n}\n\n.cadastro-title {\n  text-transform: uppercase;\n  margin-bottom: 16px;\n}\n\n.cadastro-voltar {\n  font-weight: var(--app-font-weight-semibold);\n  text-decoration: none;\n}\n\n.cadastro-voltar:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 360px) {\n  .login-brand {\n    height: 40px;\n  }\n}\n@media (max-width: 280px) {\n  .login-brand {\n    height: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
